import { render, staticRenderFns } from "./ModalShowApprovers.vue?vue&type=template&id=352df1dc"
import script from "./ModalShowApprovers.vue?vue&type=script&lang=js"
export * from "./ModalShowApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports